import Vue from "vue";

export default () => {
  Vue.filter("valueFormatCurrency", (item, currency) => {
    return item !== "-"
      ? `${currency} ${new Intl.NumberFormat().format(item)} `
      : "-";
  });
};
